
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points faibles?`}</em></p>
    <p>{`Ce vaccin n’atteint pas les taux d’efficacité enregistrés par les produits
développés par Pfizer/BioNTech ou Moderna.`}</p>
    <p>{`Comme le vaccin d'AstraZeneca, il a fait l'objet d'une polémique au printemps
suite à l'annonce de rares cas de thromboses (voir la rubrique effets
secondaires). Pour cette raison, le Danemark et la Finlande y ont renoncé.`}</p>
    <p>{`Le 10 juin, Reuters a en outre annoncé que l'Union européenne (UE) avait décidé
de ne pas retenir une option d'achat de 100 millions de doses de ce vaccin. Et
qu'elle envisageait de faire don de 100 millions de doses pour lesquelles elle
avait une autre option. L'agence de presse souligne qu'outre les questions de
sécurité, des difficultés d'approvisionnement se sont présentées. Dans le cadre
d'une commande initiale, Johnson&Johnson s'était engagé à livrer 55 millions de
doses à l'UE avant fin juin. Or, l'entreprise n'en a expédié qu'environ 12
millions à mi-juin, selon un fonctionnaire de la Commission européenne.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;